import _ from 'lodash';

import Config from 'app/common/Config';
import { loadCss, loadJs } from 'app/common/utils/RouterUtils';

const deps = _.compact([
  window.markdown
    ? undefined
    : '//cdnjs.cloudflare.com/ajax/libs/markdown.js/0.5.0/markdown.min.js',
  window.SimpleMDE
    ? undefined
    : '//cdnjs.cloudflare.com/ajax/libs/simplemde/1.11.2/simplemde.min.js',
]);

const loadCdnScripts = () =>
  deps.length > 0 ? loadJs(deps) : Promise.resolve();

const routes = {
  '/developer': {
    fetch: () =>
      Promise.all([
        import(
          /* webpackChunkName: 'developer-route' */ 'app/developer/asyncRoute'
        ),
        loadCdnScripts(),
        loadJs([`${Config.mediaUrl}build/legacy-templates.js?v=1`]),
        loadCss([
          '//cdn.jsdelivr.net/simplemde/latest/simplemde.min.css',
          `${Config.mediaUrl}build/legacy-developer.css`,
        ]),
      ]).then(([module]) => module.default),
  },
};

export default routes;
